export default __webpack_public_path__ + "static/customer-data-8ef8be91809f0e1b8e4aaaa25d335bbc.png";